<template>
<div class="planned-downtime" :class="{ 'is-page-viewer': isPageViewer }">
    <div class="notice">
        <div>Database Maintenance. Back online shortly.</div>
        <div>Enjoy this wordcloud of 200k suggestions.</div>
        <div>Made with ❤️ by guanzo</div>
        <div v-if="isPageViewer" class="larger-image-link">
            <a :href="configUrl" target="_blank">Larger version</a>
        </div>
    </div>
    <div class="wordcloud">
        <img :src="currentViewUrl"/>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

const baseUrl = `${process.env.SERVER_STATUS_ORIGIN}/suggestion-box`

export default {
    name: 'PlannedDowntime',
    data: () => ({
        viewerUrl: `${baseUrl}/wordcloud_page_viewer.png`,
        configUrl: `${baseUrl}/wordcloud_page_config.png`,
    }),
    computed: {
        ...mapGetters(['isPageViewer']),
        currentViewUrl: vm => vm.isPageViewer ? vm.viewerUrl : vm.configUrl
    },
}
</script>

<style lang="scss" scoped>
.planned-downtime {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    &.is-page-viewer .notice {
        flex-direction: column;
    }
}

.notice {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    padding: .5rem 1rem;
    max-height: 75px;

    .larger-image-link {
        position: absolute;
        bottom: 0px;
        right: 0px;
        padding: 2px;
        padding: 0 2px;
        font-size: 0.7rem;
    }
}

.wordcloud {
    @include flex-center-children;
    flex: 1;
}
</style>
